<template>
  <!-- <router-link :to="{}" class="link-uncolor game-card"> -->
  <div
    class="game-card-wrapper d-flex flex-grow-1"
    :class="{ active: isActive }"
  >
    <div
      class="game-card-content"
      :class="{ 'auto-size': !width || !height }"
      :style="coverStyle"
      v-on="$listeners"
    ></div>
  </div>
  <!-- </router-link> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { prop, propRequired } from '@/utils/factories';
// import Avatar from '@/components/images/Avatar';

export default {
  name: 'GameCard',
  // components: { Avatar },
  props: {
    game: propRequired(Object),
    isActive: prop(Boolean),
    width: prop([Number, String], 0),
    height: prop([Number, String], 0),
  },
  computed: {
    ...mapGetters(['games' /*, 'platforms'*/]),
    // gameData() {
    //   return this.games.find(game => game.id === this.game) || {};
    // },
    coverStyle() {
      const { cover } = this.game;
      return cover
        ? {
            backgroundImage: `url(${encodeURI(cover)})`,
            width: this.width ? `${this.width}px` : null,
            height: this.height ? `${this.height}px` : null,
          }
        : null;
    },
    logo() {
      return this.game.logo || null;
    },
  },
  created() {
    this.fetchGames();
  },
  methods: {
    ...mapActions(['fetchGames']),
  },
};
</script>

<style lang="scss">
.game-card-wrapper {
  /*padding: 2px;*/
  opacity: 0.5;
  .game-card-content {
    background: no-repeat center / cover rgba(34, 34, 45, 0.6);
    background-size: cover;
    border-radius: $ph-medium-radius;
    overflow: hidden;
    &.auto-size {
      @include ratio-block(100%);
    }
    b {
      @include text-multiline-ellipses(3, 1.375rem);
    }
  }
  &.active {
    opacity: 1;
    border-radius: $ph-medium-radius;
  }
}
</style>
